<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup>
const { locale } = useI18n();
const rtlLanguages = ["ar", "he", "fa"];
const isRTL = computed(() => rtlLanguages.includes(locale.value));

// Add dir and lang attributes to html
useHead({
  htmlAttrs: {
    dir: isRTL.value ? "rtl" : "ltr",
    lang: locale.value,
  },
});
</script>
